import { getSiteInfo, getSiteConfigs, setGlobalSiteConfigs, getLazySizesConfig } from '../SiteConfigs.js';
const VideoMatrixWidget = () => import(/* webpackChunkName: "VideoMatrixWidget" */  "../../../assets/js/Videos/VideoMatrixWidget.vue");

setGlobalSiteConfigs();

var viewport = $(window).width();  
var prev_viewport = viewport;

var current_total = 0;
var pix = 0; //items counter
var pitems_per_slide = 12; //how many items to start
var pstart = 0; //starting index
var pend = pitems_per_slide; //end index
var pyear = 2016;
var pyear_oldest = '03/01/2016';
var pdata = '';
var d = '';
var rix = 0; //remaining items count(12 item panels - last panel != 12)
var buffer_items = [];
var video_items = [];
var filtered_items = [];
var bottom_item_ids;
var pop_item_ids;
var day;
var featured_entry_id;
var startDay,startMonth,startYear,pday,pmonth,cyear;
var MAX_FAIL_DAYS = 30;
var ELEC_ADS_MAX_FAIL_DAYS = 90; //NEED 3+ MONTHS TO HAVE ENOUGH DATA TO TRIGGER LOAD MORE - DECREASE AFTER A DOZEN NEW VIDS ARE MADE
var fail_days_in_a_row = 0;
var check_modulesLoaded_interval = '';

var loadBtn = '<div class="loadMoreBtn"><span class="ajaxLeft"><img height="22" class="lazyload" loading="lazy" src="/asset/img/ajax-grey-sm.gif" /></span> <span class="loadMoreText">Load More</span></div>';

////////////////////////////////////////////////////////////////////////////////
// DOC READY ///////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function VideosInit() {

    $(document).ready(function () {

        MatrixWidget_init();

        $('.breaking-related .title > a').click(function (event) {

            //Get the href value. Will use at the end to go to link target.
            event = event || window.event;
            var href = $(this).closest('a').attr('href');

            var ge_action = 'Click';
            var ge_category = 'Related Videos';
            var ge_label = 'Video Permalink';

            //Wrap event tracking call to prevent premature termination of this function.
            try {
                _gaq.push(['_trackEvent', ge_category, ge_action, ge_label]);
                console.log('trackevent: ' + ge_category + ' ' + ge_action + ' ' + ge_label);
            } catch (err) {
            }
            if (event.ctrlKey || event.metaKey) { //If right-click or control click
                return true;
            } else {
                window.setTimeout('document.location = "' + href + '"', 100); //Go to hyperlink
                return false;
            }
        });
        //tracks the new layout permalink
        $('.breaking-related .archive-item .archive-content-wrapper strong > a').click(function (event) {

            //Get the href value. Will use at the end to go to link target.
            event = event || window.event;
            var href = $(this).closest('a').attr('href');

            var ge_action = 'Click';
            var ge_category = 'Related Videos';
            var ge_label = 'Video Permalink';

            //Wrap event tracking call to prevent premature termination of this function.
            try {
                _gaq.push(['_trackEvent', ge_category, ge_action, ge_label]);
                console.log('trackevent: ' + ge_category + ' ' + ge_action + ' ' + ge_label);
            } catch (err) {
            }
            if (event.ctrlKey || event.metaKey) { //If right-click or control click
                return true;
            } else {
                window.setTimeout('document.location = "' + href + '"', 100); //Go to hyperlink
                return false;
            }
        });

        /* -- RWD MODULES POSITIONING -- */
        //we setup an interval to check if widgets are loaded yet
        check_modulesLoaded_interval = setInterval(checkModulesLoaded, 1000);
        //IF VIEWPORT IS RESIZED RUN position function
        $(window).resize(function () {
            viewport = $(window).width();
            if (viewport != prev_viewport) {
                positionVideoModules();
            }
            prev_viewport = viewport;
        });
        /* ----------------------------- */


        /*----- CUSTOM COLDMAN ---- */
        /*checks for ooyala vpr div identifier, then adds top clickable layer*/
        /*viewport = $(window).width();
        //console.log('vps: '+viewport);
        if(viewport>=768 && viewport<=1024){ //tablet only 
          vpr_check_interval = setInterval(checkVPR, 1000); //since we're checking to make sure google gpt api is ready we need to keep checking
        }*/
        /* ------ CUSTOM GOLDMAN --- */


        /*------ JWPLAYER FIX FOR PREROLL MUTING AUDIO ------- */
        var isjwplayer = $('.rc_video_player_container .jwplayer').length;

        if (isjwplayer > 0) { //check_modulesLoaded_interval
            jwplayer().on("adComplete", function () {
                jwplayer().setMute(false);
            });
        }
        /*------ JWPLAYER FIX -----*/


        //parse daily video jason to dynamically fill 12 vids per click
        if ($(".load-more").length > 0) {
            $(".load-more").append(loadBtn);
        }

        //hit ITN feed to add to exclusion array
        if (siteName == 'politics') {
            //load_in_the_news();
        }

        //both cat-item/cat-item-row exist on all video pages so no need to check for existance/undefined
        //add items(visible in widget) to exclusion array(bottom)
        $(".cat-item-row").each(function (i, ele) {
            bottom_item_ids = $(this).attr("data-id");
            video_items.push(bottom_item_ids);
        });

        //add items to exclusion array(matrix)
        $(".cat-item").each(function (i, ele) {
            pop_item_ids = $(this).attr("data-id");
            video_items.push(pop_item_ids);
        });

        //add featured videos to exclusion array - Election 2016 Ads Landing Page ONLY
        var feat_vid_ids = '';
        var feat_small_vid_ids = '';
        
        if ($("body.election_2016_ads").length > 0) {
            if ($(".featured_vid_wrapper").length > 0) {
                $(".featured_vid_wrapper").each(function (i, ele) {
                    feat_vid_ids = $(this).attr("data-id");
                    video_items.push(feat_vid_ids);
                });
            }

            if ($(".featured_vid_small_wrapper").length > 0) {
                $(".featured_vid_small_wrapper").each(function (i, ele) {
                    feat_small_vid_ids = $(this).attr("data-id");
                    video_items.push(feat_small_vid_ids);
                });
            }
        }

        //add featured item to exclusion array
        if ($(".video-top").length > 0) { //check to see if featured exists as to not include undefined - only works on main video landing page
            featured_entry_id = $(".video-top").attr("data-entry-id");
            video_items.push(featured_entry_id);
        }

        //exclusion array - dubugger
        //console.log("Total Items in EXCL Arr: " + video_items.length)

        //get first posts date(first default panel) - sets starting point for load more
        startDay = $('.cat-item').first().attr("data-day");
        startMonth = $('.cat-item').first().attr("data-month");
        startYear = $('.cat-item').first().attr("data-year");
        var startDateStr = startDay + '/' + startMonth + '/' + startYear;

        pday = parseInt(startDay) + 1; //current day of last default post
        pmonth = parseInt(startMonth); //current month of last default post
        cyear = parseInt(startYear); //current year of last default post

        if (siteName == 'world' || siteName == 'future' || siteName == 'health' || siteName == 'defense' || siteName == 'energy' || siteName == 'science') {
            pyear = cyear;
        }

        //load dynamic video panel(12 vids/panel)
        $(".load-more").click(function () {

            try {
                var cur_body_class = document.body.getAttribute('class').split(/\s+/);
                var bc;
                if ($("body.video-landing").length > 0) {
                    bc = 'Video Landing Page';
                } else {
                    bc = 'Video Permalink';
                }

                _gaq.push(['_trackEvent', 'Video Pages Event', 'Load More Videos Btn', 'Section: ' + bc + '']);
            } catch (err) {
            }

            if (pyear > 2016 || (pyear == 2016 && pmonth >= 2)) { //how far back to we load archives => 3/01/16 -> archives stop 2/27/16(creation date)
                $(".ajaxLeft").css({"display": "inline-block"});
                console.log('filtered items: ' + filtered_items.length);
                console.log('items per slide: ' + pitems_per_slide);
                //not done loading current feeds items
                //if(pix < current_total){
                if (filtered_items.length >= pitems_per_slide) {
                    pstart = pix; //grab current loaded num 
                    pend = pix + pitems_per_slide;

                    var display_items = filtered_items.splice(0, 12);

                    console.log('display_items');
                    console.log(display_items);

                    pappendFeedData(display_items, pstart, pend, pitems_per_slide, current_total);
                    $(".ajaxLeft").css({"display": "none"});
                } else { //check previous day feed

                    var temp_date = new Date(pyear, pmonth, pday);
                    //console.log('.load-more click before : '+temp_date);
                    temp_date.setDate(temp_date.getDate() - 1); // Decrements a day
                    //console.log('.load-more click else: '+temp_date);

                    pyear = temp_date.getFullYear();
                    pmonth = temp_date.getMonth();
                    pday = temp_date.getDate();

                    pix = 0;
                    pstart = 0;
                    pend = pitems_per_slide - 1;

                    p_parseFeed(pstart, pend, pitems_per_slide);

                }
            } else { //we know there are no more posts so we disable button
                $(".load-more").hide();
            }
        });


    }); //end DOC READY
    
}

function load_in_the_news(){ //get visible videos(5) from widget, not all posts, to add to exclusion array 
    $.ajax({
        url: window.location.protocol+'//www.realclearpolitics.com/feed/video_in_the_news.json',
        dataType: 'json',
        async:false,
        success: function(fdata){
            d = fdata;

            $.each(fdata.video_in_the_news, function(i, item) {
                var news_item_id = item.id;
                if( i <= 4 ){
                    video_items.push(news_item_id);
                }
            }); //end each feed item

        } //end success
    });
}

//start load more videos
function p_parseFeed(pstart, pend, pitems_per_slide){
    //JSON CALL CACHED FOR 1 MINUTE
    //console.log('pstart: '+pstart+', pend: '+pend+', pitems_per_slide: '+pitems_per_slide+', pyear: '+pyear);
    var pmonth_display = pmonth + 1;
    var cache_date = new Date;
    var cache_buster = cache_date.getMonth() + '' + cache_date.getDate() + '' + cache_date.getHours() +''+cache_date.getMinutes();
    var d_loadJSON_url;
    //d_loadJSON_url = "http://"+window.location.hostname + "/sponsored_content/kauffman/json/policy_digest/"+pyear+".js?cache="+cache_buster+"";
    if( $("body.election_2016_ads").length > 0 ){
        d_loadJSON_url = window.location.protocol+"//" + window.location.hostname + "/video/"+cyear+"/"+pad(pmonth_display)+"/"+pad(pday)+"/election_ads_archive.json";
    }else{
        //console.log('Month:'+pmonth+" Day: "+pday);
        if(parseInt(pday) < 10){
            pday = "0" + pday.toString();
        }

        if(parseInt(pmonth_display) < 10){
            pmonth_display = "0" + pmonth_display.toString();
        }
        //d_loadJSON_url = "http://" + window.location.hostname + "/video/"+cyear+"/"+pad(pmonth_display)+"/"+pad(pday)+"/archive.json";
        //d_loadJSON_url = "http://" + window.location.hostname + "/video/"+cyear+"/"+pmonth_display+"/"+pad(pday)+"/archive.json";
        d_loadJSON_url = window.location.protocol+"//" + window.location.hostname + "/video/"+cyear+"/"+pmonth_display+"/"+pday+"/archive.json";
        //console.log(d_loadJSON_url);
        //console.log("--------------------------------------------------------------------------");
    }


    //has to be synchronous becuase we have to wait on finish to check counts in order to load more if necessary
    $.ajax({
        url: d_loadJSON_url,
        dataType: 'json',
        async:false,
        success: function(fdata){
            pdata = fdata;
            $.each(fdata.feed.item, function(i, item) {
                var thisid = item.id;
                var index = i+1;
                if(video_items.indexOf(thisid) == -1) {
                    filtered_items.push(item);
                }
            });

            //console.log('filtered items: ' + filtered_items.length);

            if(filtered_items.length >= pitems_per_slide){
                current_total = fdata.feed.num_posts; //feed total items
                var display_items = filtered_items.splice(0,12);

                console.log('display_items');
                console.log(display_items);
                pappendFeedData(display_items, pstart, pend, pitems_per_slide, current_total);
                $(".ajaxLeft").css({ "display" : "none" });

            }else{

                var temp_date = new Date(pyear+'/'+(pmonth+1)+'/'+pday);
                //console.log('ajax success before decrement: '+temp_date);
                temp_date.setDate(temp_date.getDate() - 1); // Decrements a day
                //console.log('ajax success else: '+temp_date);

                //console.log('Before Assign Month:'+pmonth+" Day: "+pday);
                pyear = temp_date.getFullYear();
                pmonth = temp_date.getMonth();
                pday = temp_date.getDate();
                //console.log('After Assign Month:'+pmonth+" Day: "+pday);

                pix = 0;
                pstart = 0;
                pend = pitems_per_slide - 1;

                p_parseFeed(pstart, pend, pitems_per_slide);
            }
        },
        complete: function(xhr, data) {
            //console.log(siteName + ' complete');
            if(siteName == 'world' || siteName == 'future' || siteName == 'health' || siteName == 'defense' || siteName == 'energy' || siteName == 'science' ){
                var vid_control = 1;
            }else{
                var vid_control = 0;
            }
            if(xhr.status != 200 && vid_control == 1) {
                // Fail
                //console.log(siteName + ' inside if');
                fail_days_in_a_row++;
                if(fail_days_in_a_row < MAX_FAIL_DAYS) {

                    var temp_date = new Date(pyear, pmonth, pday);
                    temp_date.setDate(temp_date.getDate() - 1); // Decrements a day

                    pyear = temp_date.getFullYear();
                    pmonth = temp_date.getMonth();
                    pday = temp_date.getDate();
                    //console.log('xhr 200: '+temp_date);

                    pix = 0;
                    pstart = 0;
                    pend = pitems_per_slide - 1;

                    p_parseFeed(pstart, pend, pitems_per_slide);
                } else {
                    $(".loadMoreBtn").css({ "display" : "none" });
                }
            }
        },
        statusCode: {
            404: function() {
                fail_days_in_a_row++;
                if(fail_days_in_a_row < ELEC_ADS_MAX_FAIL_DAYS) {

                    var temp_date = new Date(pyear, pmonth, pday);
                    temp_date.setDate(temp_date.getDate() - 1); // Decrements a day

                    pyear = temp_date.getFullYear();
                    pmonth = temp_date.getMonth();
                    pday = temp_date.getDate();
                    //console.log('404 if: '+temp_date);

                    pix = 0;
                    pstart = 0;
                    pend = pitems_per_slide - 1;

                    p_parseFeed(pstart, pend, pitems_per_slide);
                } else {
                    $(".loadMoreBtn").css({ "display" : "none" });
                }
            },
            403: function() {
                fail_days_in_a_row++;
                if(fail_days_in_a_row < ELEC_ADS_MAX_FAIL_DAYS) {

                    var temp_date = new Date(pyear, pmonth, pday);
                    temp_date.setDate(temp_date.getDate() - 1); // Decrements a day

                    pyear = temp_date.getFullYear();
                    pmonth = temp_date.getMonth();
                    pday = temp_date.getDate();
                    //console.log('403 if: '+temp_date);

                    pix = 0;
                    pstart = 0;
                    pend = pitems_per_slide - 1;

                    p_parseFeed(pstart, pend, pitems_per_slide);
                } else {
                    $(".loadMoreBtn").css({ "display" : "none" });
                }
            }
        }
    });


}

function pappendFeedData(display_items, set_start, set_limit, pitems_per_slide, current_total){

    $.each(display_items, function(i, item) {
        var itemTitle = item.title.replace(/&acute;/g, "&#039;");
        var pubDate = item.date_posted;
        var date = new Date(pubDate);
        var months = Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
        var stryear = String(date.getFullYear());
        //var itemDate = months[date.getMonth()] +"."+ date.getDate() +"." + stryear.substring(4,2);
        var itemDate = months[date.getMonth()] +" "+ date.getDate() +", " + stryear;

        var itemID = item.id;
        var itemImg = item.image;
        var itemLink = item.link.replace('http://', 'https://');

        var dhtml = ' <div class="cat-item" data-id="'+itemID+'" data-day="" data-month="" data-year="">'
            + '<div class="photo"><a href="'+itemLink+'"><div class="dummy"></div><div style="background-image:url('+itemImg+');" class="center_crop_image"></div></a></div>'
            + '<span class="date">'+itemDate+'</span>'
            + '<div class="title ajaxTitle"><a href="'+itemLink+'">'+itemTitle+'</a></div>'
            + '</div> ';

        $('.cat-wrapper').append(dhtml);

        pix++; //increast item counter          
    });
}
//end load more

//THIS INTERVAL FUNC CHECKS IF WIDGETS ARE LOADED AND READY TO BE MOVED
function checkModulesLoaded(){
    //does widget exist
    if($('.beta .widget_slot[data-widget-title="In The News"]').length>0){
        //run position function
        positionVideoModules();
        //clear interval
        clearInterval(check_modulesLoaded_interval);
    }else{
        return false;
    }
}
//RWD MODULES POSITIONING
function positionVideoModules(){
    //MOVE RC MODULES TO LC
    if(viewport<768){
        //$(".load-more").remove();
        $(".load-more").insertAfter(".cat-wrapper");
        $('.beta .widget_slot[data-widget-title="In The News"]').insertBefore('div.alpha #political'); //append ITN widget under breaking post(top)
        $('.beta .widget_slot[data-widget-title="Most Popular Videos"]').insertAfter('#rc-latest-political-videos-app'); //place AD after load more button 

        if(siteName == 'politics'){
            isITNLoaded('.alpha .widget_slot[data-widget-title="Most Popular Videos"]', 'after');
        }

    }else{ //move back to RC
        $(".loadMoreBtn").remove();
        $(".load-more").append(loadBtn);
        $('div.alpha .widget_slot[data-widget-title="In The News"]').insertBefore('.beta .social_links');
        $('div.alpha .widget_slot[data-widget-title="Most Popular Videos"]').insertBefore('.beta .cal_container');
    }
}




/* ---------- CUSTOM GOLDMAN ------- */
/*function checkVPR(){ 

    ad_playing_style = $('#ooyalaplayer .oo_ads_countdown').css('display'); 
    //console.log('test:'+ ad_playing_style);

    if(ad_playing_style=='block'){ //ad playing
      clearInterval(vpr_check_interval); 

      //console.log('goldmanclickthrough exists: '+ $('#ooyalaplayer .innerWrapper .goldmanclickthrough').length);
      if( $('#ooyalaplayer .innerWrapper .goldmanclickthrough').length == 0){
        $('#ooyalaplayer .innerWrapper').append('<div class="goldmanclickthrough"></div>'); 
        setUpClickthrough();
      } 
    }else{ //no ad playing         
      $('#ooyalaplayer .innerWrapper .goldmanclickthrough').hide();
  return false;
    }
  
}*/

function setUpClickthrough(){
    $('.goldmanclickthrough').click(function(){

        //hide the layer so you can continue playing the video 
        $('#ooyalaplayer .innerWrapper .goldmanclickthrough').hide();

        window.open('http://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=isi&pl=VAST&optOut=0&interactionsStr=33849957%7E%7E0%5EClick.Linear.155885332%7E0%7E1%7E1%7E0%7E0%7E155885333%7E0&pos=9723&ebRandom=187393764&dg=4631463&ta=-1&sessionid=3367242120803726772&rtu=$$http://www.goldmansachs.com/citizenship/10000-small-businesses/US/index.html?cid=MM33849957$$', '_blank');
    });
}

/* -------- CUSTOM GOLDMAN -------- */


function fixToolbarToElement(toolbar, pageElement) {


    var gamma_left = $(pageElement).offset().left;
    var gamma_top = $(pageElement).offset().top;
    var gamma_width = $(pageElement).width();

    $(toolbar).css("top",gamma_top).css("left",gamma_left).css("position","fixed").css("width",gamma_width);

}

//helper function to ensure day of month remains 2 digit
function pad(n) {
    //console.log("before: "+n);
    n = parseInt(n);
    //n = (n < 10) ? ("0" + n.toString() ) : n;

    if(n < 10){
        n = "0" + n.toString();
    }
    //console.log("after: "+n);
    return n;
}

/*

Latest Political Videos - Vue.js app

Summary:
Uses monthly json files to populate a 4-column list with a 'more' button.
Like the lists index page, but with daily instead of monthly json archive files.
Also looks for video_political.json (matrix) and uses that as first ajax file,
  then makes sure archive files don't duplicate any videos that were in matrix.

Dependencies:
vue.min.js 2.1.9 (standalone version)
Proper body class of .video or .video-landing

Browser Requirements:
IE9+

Table of Contents:
UTILITY FUNCTIONS
CONSTANTS
VUE COMPONENTS

*/

///////////////////////
// UTILITY FUNCTIONS //
///////////////////////

function getAjax(url, finished) {

    var xhr;
    if(window.XMLHttpRequest) {
        xhr = new XMLHttpRequest();
    } else {
        xhr = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xhr.open('GET', url);
    xhr.onreadystatechange = function() {
        if(xhr.readyState>= 4) {
            if(xhr.status==200) {
                finished(xhr.responseText);
            } else {
                finished(false);
            }
        }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send();
    return xhr;
}

function num_with_ordinal_suffix(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

function daysInMonth(month,year) { // 1 based, not 0 based
    return new Date(year, month, 0).getDate();
}

function pad_num(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length-size);
}

///////////////
// CONSTANTS //
///////////////

var JSON_BASE_URL = '/video/';
var THIS_DATE = new Date();
var EARLIEST_YEAR = 2016;
var EARLIEST_MONTH = 1;
var EARLIEST_DAY = 31;
var MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var CACHEBUST = new Date().getTime();

////////////////////
// VUE COMPONENTS //
////////////////////
function MatrixWidget_init() {
    if (window.Vue) { // Wrapped in this just in case Vue.js not included

        function init_matrix_widget(selector){
            /*
                Top-level app container
                Holds the main videos area and the load-more button
            */
            Vue.component('rc-container', VideoMatrixWidget);

            // Start App
            new Vue({
                el: selector,
            });
        }

        function lazy_init_matrix_widget(selector){

            var lazy_init_callback = function(){
                if( window.$(selector) && window.$(selector).inViewport(50) ){
                    init_matrix_widget(selector);
                    $(window).off("scroll rezise", lazy_init_callback);
                }
            }
        
            $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
        }

        lazy_init_matrix_widget('#rc-latest-political-videos-app');

    } // end if(window.vue)
}

function check_if_ad_free(video_link) {
    //We check if the page have a video
    if(jw_permalink_vids_exist === true) {
        //We create the necessary variables for the free-ads link
        var free_ads = "fPtyCotK";
        // var ads = "EAYoNgFe";
        var video_container = document.querySelector('#video_cont');
        var video_data = document.querySelector('#video-data');
        var video_id = video_data.dataset.videoid;
        var cookie_exists = readCookie('evaf');
        
        //We check if the cookie exists
        if(cookie_exists) {
        var video_link = "https://cdn.jwplayer.com/players/"+video_id+"-"+free_ads+".js";
        }
        return video_link;
    }
}
/*

END Latest Political Videos - Vue.js app

*/

export default VideosInit;